import axios from 'axios'
import { setLoading } from '../redux/features/loadingSlice'
import { toastMaker } from './utility';
import store from '../redux/store';

let token = localStorage.getItem('jwtToken');
const matrimonyInstance = axios.create({

  baseURL: `${process.env.REACT_APP_MATRIMONY_API_BASE}api/`,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    'Authorization': `${token}`
  }
});

matrimonyInstance.interceptors.request.use(request => {
  const token = localStorage.getItem('jwtToken');
  if (token) {
    request.headers['Authorization'] = `${token}`;
  }
  store.dispatch(setLoading(true))
  return request;
}, error => {
  return Promise.reject(error);
});

matrimonyInstance.interceptors.response.use(
  response => {
    store.dispatch(setLoading(false))
    return response
  }, // Directly return successful responses.
  async error => {
    console.log("error is", matrimonyInstance, error);
    store.dispatch(setLoading(false))

    const originalRequest = error.config;
    // if (error.response.status === 410 && !originalRequest._retry) {
    //     originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
    //     try {
    //         const refreshToken = localStorage.getItem('jwtToken'); // Retrieve the stored refresh token.
    //         // Make a request to your auth server to refresh the token.
    //         const response = await axios.post('https://your.auth.server/refresh', {
    //             refreshToken,
    //         });
    //         const { accessToken, refreshToken: newRefreshToken } = response.data;
    //         // Store the new access and refresh tokens.
    //         localStorage.setItem('jwtToken', accessToken);
    //         // Update the authorization header with the new access token.
    //         matrimonyInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    //         return matrimonyInstance(originalRequest); // Retry the original request with the new access token.
    //     } catch (refreshError) {
    //         // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
    //         toastMaker("Session expired. Login Again", "Error")
    //         localStorage.removeItem('jwtToken');
    //         window.location.href = '/login';
    //         return Promise.reject(refreshError);
    //     }
    // } else
    if (error?.response?.status === 400) {
      if (error.response?.data?.message) {
        toastMaker(error.response?.data?.message, "error")
      } else
        toastMaker(error.response?.data?.error, "error");
    } else if (error?.response?.status === 500) {
      console.log("in error 500");
      toastMaker("Something went wrong", "error");
    } else if (error?.response?.status === 500) {
      console.log("in error");
      toastMaker("Something went wrong", "error");
    }
    return Promise.reject(error); // For all other errors, return the error as is.
  }
);

export default matrimonyInstance